export const getAddAnotherAddressAnalytics = () => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction:
      "my account:account settings:modal:add address:add another address",
    eventName:
      "my account:account settings:modal:add address:add another address",
    eventStatus: "n/a",
    eventMsg: "n/a",
    eventType: "navigation",
    internalLinkName: "add another address",
    internalLinkPosition: "my account",
    internalLinkType: "my account:addresses",
    internalLinkURL: "n/a",
    internalLinkZoneName: "my account:account settings:modal:add address",
  })
}

export const addAddAddressAnalytics = (status = "", errors = [], edit) => {
  const title = edit ? "edit address:save" : "add address:submit"
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:account settings:modal:${title}`,
    eventName: `my account:account settings:modal:${title}`,
    eventStatus: status,
    eventMsg: errors ? errors.join("|")?.toLowerCase() : "n/a",
    eventType: "navigation",
    internalLinkName: edit ? "save" : "submit",
    internalLinkPosition: edit
      ? "my account:account settings"
      : "account settings",
    internalLinkType: "my account:addresses",
    internalLinkURL: "n/a",
    internalLinkZoneName: `my account:account settings:modal:${
      edit ? "edit address" : "add address"
    }`,
  }

  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
  })
  delete window?.pageObj
}
